import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import { Logout as LogoutIcon, Person as PersonIcon } from '@mui/icons-material';

interface UserMenuProps {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
	onLogout: () => void;
	displayName: string;
	email: string;
}

const UserMenu: React.FC<UserMenuProps> = ({
	anchorEl,
	open,
	onClose,
	onLogout,
	displayName,
	email,
}) => {
	const handleLogout = () => {
		onLogout();
		onClose();
	};

	return (
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={onClose}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			PaperProps={{
				sx: {
					minWidth: 220,
				}
			}}
		>
			<MenuItem disabled>
				<ListItemIcon>
					<PersonIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText
					primary={displayName}
					secondary={email}
					slotProps={{ primary: { fontWeight: 'bold' } }}
				/>
			</MenuItem>
			<Divider />
			<MenuItem onClick={handleLogout}>
				<ListItemIcon>
					<LogoutIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Logout</ListItemText>
			</MenuItem>
		</Menu>
	);
};

export default UserMenu;
